import { useFetchAttributes } from '@/hooks/features/attributes/useFetchAttributes'
import { useFetchBrands } from '@/hooks/features/brands/useFetchBrands'
import { useFetchCategories } from '@/hooks/features/categories/useFetchCategories'

export const useProductMetadata = () => {
  const { data: attributes, loading: attributesLoading } = useFetchAttributes({
    shouldFetchList: true,
  })

  const { data: categories, loading: categoriesLoading } = useFetchCategories({
    shouldFetchList: true,
  })

  const { data: brands, loading: brandsLoading } = useFetchBrands({
    shouldFetchList: true,
  })

  return {
    attributes,
    attributesLoading,
    categories,
    categoriesLoading,
    brands,
    brandsLoading,
  }
}
